import logoLumisight from 'src/assets/images/logos/lumisight.png';
import logoLumisightFull from 'src/assets/images/logos/lumisight-full.png';
import background from 'src/assets/images/background.svg';
import backgroundLogin from 'src/assets/images/background_login.png';

export const IMAGES = {
  logoLumisight,
  logoLumisightFull,
  background,
  backgroundLogin,
};
